import { createAction } from 'redux-actions';

const action = createAction('SET_COMMENT_DIRTY');
export const setCommentsDirty = (context: CommentContext) => action({ args: { context } });
